import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { createNewAlbum } from "../../firebase";

export function GalleryNew() {
    const navigate = useNavigate();

    useEffect(() => {
        createNewAlbum().then((id) => {
            navigate(`/album/${id}/edit`);
        });
    }, [navigate]);

    return (
        <div style={{ margin: "auto", textAlign: "center" }}>
            <ClipLoader loading color="#c0ba62" size={48} />
            <p>
                <strong>Creating new album...</strong>
            </p>
        </div>
    );
}
